import React from 'react';

const FaqRight = () => {
    return (
        <div style={{
            backgroundColor: '#0a3d62',
            borderRadius: '12px',
            padding: '40px 30px',
            textAlign: 'center',
            boxShadow: '0 20px 40px rgba(10, 61, 98, 0.15)',
            position: 'sticky',
            top: '120px'
        }}>
            <div style={{
                width: '60px',
                height: '60px',
                backgroundColor: 'rgba(255,255,255,0.1)',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 20px auto'
            }}>
                <i className="fas fa-headset" style={{ fontSize: '24px', color: '#25b579' }}></i>
            </div>
            <h3 style={{ color: '#ffffff', fontSize: '1.6rem', fontWeight: '700', marginBottom: '15px' }}>
                Still have questions?
            </h3>
            <p style={{ color: '#e0e0e0', fontSize: '1.05rem', lineHeight: '1.6', marginBottom: '30px' }}>
                Our property experts are standing by. Get in touch with us today for a free consultation.
            </p>
            <a href="/contact" style={{
                display: 'inline-flex',
                alignItems: 'center',
                backgroundColor: '#25b579',
                color: '#ffffff',
                padding: '14px 30px',
                fontWeight: '700',
                borderRadius: '6px',
                textDecoration: 'none',
                transition: 'all 0.3s ease',
                width: '100%',
                justifyContent: 'center'
            }}
            onMouseEnter={(e) => {
                e.currentTarget.style.background = '#1e9b67';
                e.currentTarget.style.transform = 'translateY(-2px)';
            }}
            onMouseLeave={(e) => {
                e.currentTarget.style.background = '#25b579';
                e.currentTarget.style.transform = 'translateY(0)';
            }}>
                Contact Us Now
                <i className="fas fa-arrow-right" style={{ marginLeft: '10px' }}></i>
            </a>
            <div style={{ marginTop: '20px', borderTop: '1px solid rgba(255,255,255,0.1)', paddingTop: '20px' }}>
                <a href="tel:07985193841" style={{ color: '#ffffff', textDecoration: 'none', fontSize: '1.1rem', fontWeight: '600' }}>
                    <i className="fas fa-phone-alt" style={{ color: '#25b579', marginRight: '10px' }}></i>
                    07985 193841
                </a>
            </div>
        </div>
    );
};

export default FaqRight;
